// @flow
import React from 'react';
import { Modal } from 'antd';
import { SpH5, SpButton } from 'components/DesignKit';

type Props = {
  visible: boolean,
  close: Function,
  submit: Function,
  adminTerminalDetails: Object,
};

const DeleteSelectedTerminal = (props: Props) => {
  const {
    visible,
    close,
    submit,
    adminTerminalDetails,
  } = props;

  const deleteSelectedTerminal = () => {
    submit(adminTerminalDetails && adminTerminalDetails.gid);
  };

  return (
    <Modal
      centered
      closable={false}
      visible={visible}
      footer={[
        <SpButton onClick={() => close()} type="secondary">Cancel</SpButton>,
        <SpButton onClick={deleteSelectedTerminal} type="danger">Delete</SpButton>,
      ]}
      title="Delete Terminal"
    >
      <div className="px-4">
        <h6 className="mt-1 mb-2">Are you sure you want to delete this Terminal?</h6>
        <SpH5 className="pb-3">
          <div>{adminTerminalDetails.deviceName ? adminTerminalDetails.deviceName : <>&#8211;</>}</div>
        </SpH5>
      </div>
    </Modal>
  );
};

// $FlowFixMe
export default DeleteSelectedTerminal;
